import type { HelpFile } from '../../types/help'
import { ServiceAccountsTestIds } from '../../../testids/ServiceAccountsTestIds'

export const serviceAccountsHelp: HelpFile = {
  docPage: '/docs/admin/service-accounts',
  texts: {
    [ServiceAccountsTestIds.serviceAccountsList]:
      'Non-human authentication identities used by automation, scripts, and integrations to call this app via API keys.',
    [ServiceAccountsTestIds.btnCreateServiceAccount]:
      'Create a new service account. The account starts with no API keys — mint one from the detail page once it exists.',
    [ServiceAccountsTestIds.btnCreateEmpty]: null,
    [ServiceAccountsTestIds.colName]:
      'Display name of the service account — used in audit logs and API-key headers.',
    [ServiceAccountsTestIds.colActiveKeys]:
      'Number of API keys currently active for this account. Inactive accounts always show 0.',
    [ServiceAccountsTestIds.colStatus]:
      'Active service accounts can authenticate via API keys; deactivating revokes all keys instantly.',
    [ServiceAccountsTestIds.colCreated]:
      'Date the service account was created.',
    [ServiceAccountsTestIds.createDialogTitle]: null,
    [ServiceAccountsTestIds.createForm]: null,
    [ServiceAccountsTestIds.createInputName]:
      'Unique, human-readable name for the service account (1–100 characters).',
    [ServiceAccountsTestIds.createInputDescription]:
      'Optional free-text description (up to 500 characters) describing what the account is used for.',
    [ServiceAccountsTestIds.emptyState]: null,
  },
}
